import { COLOR } from '../color';

export const WIND_VANE_THEME = {
    DIRECTION_LINE_GUSTY: COLOR.RED_BRIGHT_07,
    DIRECTION_LINE: COLOR.WHITE_07,
    INNER_RING_STROKE: COLOR.WHITE_07,
    OUTER_RING_FILL: COLOR.BLACK_07,
    WIND_SPEED_TEXT: COLOR.WHITE_07
};
